import { toKebabCase } from '@/utils/helpers';
import { Country, ListingStatus, PropertyEnum } from '@proprioo/hokkaido';

import {
  DistributionProps,
  ListingDistribution,
  ListingProps
} from '../interfaces';
import { flatPropertyTypes, housePropertyTypes } from '../utils';
import {
  LIGHTSHOP_CLIENT_ID,
  LIGHTSHOP_CLIENT_ID_ITALY,
  LIGHTSHOP_CLIENT_SECRET,
  LIGHTSHOP_CLIENT_SECRET_ITALY,
  LISTING_PLATFORM_URL
} from '@/constants/global';

export const hasNeverBeenPublished = (listing: ListingProps): boolean =>
  !listing.firstPublication;

export const isPublished = (listing: ListingProps): boolean =>
  [ListingStatus.PUBLISHED].includes(listing.valide);

export const isDistributionEnabled = (
  id: ListingDistribution,
  distributions: DistributionProps[]
) =>
  distributions.some(
    ({ distribution: { platform, activated } }) => platform === id && activated
  );

export const isHouseOrFlat = (propertyType?: PropertyEnum): boolean => {
  if (!propertyType) return false;

  return [...flatPropertyTypes, ...housePropertyTypes].includes(propertyType);
};

export const isFrenchCountryListing = (
  listingCountry = Country.FRANCE
): boolean => listingCountry === Country.FRANCE;

export const isItalianCountryListing = (listingCountry?: Country) =>
  listingCountry === Country.ITALY;

export const getLightShopCredentialsByListingCountry = (
  listingCountry: Country
) => {
  return isItalianCountryListing(listingCountry)
    ? {
        clientId: LIGHTSHOP_CLIENT_ID_ITALY,
        secret: LIGHTSHOP_CLIENT_SECRET_ITALY
      }
    : { clientId: LIGHTSHOP_CLIENT_ID, secret: LIGHTSHOP_CLIENT_SECRET };
};

export const generateWikicasaLink = ({
  city,
  price,
  surfaceArea
}: ListingProps): string =>
  `https://www.wikicasa.it/vendita-case/${toKebabCase(city)}?PrezzoMinimo=${price}&PrezzoMassimo=${price}&SuperficieMinima=${surfaceArea}&SuperficieMassima=${surfaceArea}`;

export const generateCasaLink = ({
  price,
  surfaceArea
}: ListingProps): string =>
  `https://www.casa.it/srp?tr=vendita&mqMin=${surfaceArea}&mqMax=${surfaceArea}&priceMin=${price}&priceMax=${price}&propertyTypeGroup=case`;

export const generateImmobiliareLink = ({
  city,
  price,
  surfaceArea
}: ListingProps): string =>
  `https://www.immobiliare.it/vendita-case/${toKebabCase(city)}?prezzoMinimo=${price}&prezzoMassimo=${price}&superficieMinima=${surfaceArea}&superficieMassima=${surfaceArea}`;

export const generateCasavoLink = ({ id, country }: ListingProps): string => {
  // even though this method is currently only used on Italian flow it is ready to be used also for French flow
  const annonceLink = country === Country.FRANCE ? 'annonce' : 'annuncio';
  return `${LISTING_PLATFORM_URL}/${annonceLink}/${id}/`;
};
